/**
 * @module:  效率管理相关页面
 * @author Liang Huang
 * @date 2020-10-14 09:54:42
 */
import { lazy } from 'react';
import { retry } from '@src/utils/tool';

// 工作效率
export const MonitorDashboard = lazy(() => retry(() => import('@Monitor/Dashboard/index')));
// 更多统计
export const MonitorAllStats = lazy(() => retry(() => import('@Monitor/AllStats/index')));
// 绩效统计
export const MonitorReport = lazy(() => retry(() => import('@Monitor/Report/index')));
// 工作实况
export const MonitorCurdesktop = lazy(() => retry(() => import('@Monitor/CurDesktop')));
// 预警统计
export const MonitorWarnStat = lazy(() => retry(() => import('@Monitor/WarnStat')));
// 预警日志
export const MonitorWarnLog = lazy(() => retry(() => import('@Monitor/WarnLog')));
// 预警日志详情
export const MonitorWarnDetail = lazy(() => retry(() => import('@Monitor/WarnDetail')));
// 屏幕截图
export const ScreenShot = lazy(() => retry(() => import('@src/pages/Monitor/Screenshot')));
// 钉钉授权失败
export const DingNoRole = lazy(() => retry(() => import('@Monitor/NoRole')));
